import { useAsync } from 'react-use'
import { fetchEvent } from '@/services/client.service'
import { generateBech32IdFromETag, tagNameEquals } from '@/lib/tag'
import { HugeiconsIcon } from '@hugeicons/react'
import { ThumbsUpIcon } from '@hugeicons/core-free-icons'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import Notification from './Notification'
import { useTranslation } from 'react-i18next'

export function PollResponseNotification({
  notification,
  isNew = false
}: {
  notification: Event
  isNew?: boolean
}) {
  const { t } = useTranslation()
  const eventId = useMemo(() => {
    const eTag = notification.tags.find(tagNameEquals('e'))
    return eTag ? generateBech32IdFromETag(eTag) : undefined
  }, [notification])
  const { value: pollEvent } = useAsync(async () => {
    if (!eventId) return undefined
    return fetchEvent(eventId)
  }, [eventId])

  if (!pollEvent) {
    return null
  }

  return (
    <Notification
      notificationId={notification.id}
      icon={<HugeiconsIcon icon={ThumbsUpIcon} size={24} className="text-violet-400" />}
      sender={notification.pubkey}
      sentAt={notification.created_at}
      targetEvent={pollEvent}
      description={t('voted in your poll')}
      isNew={isNew}
    />
  )
}
